var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Email_MLR_Status",
    "data-name": "Email MLR Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M6,12a6,6,0,1,1,6-6A6.007,6.007,0,0,1,6,12Zm.571-7.615h0L3.5,7.46V8.5H4.539L7.613,5.432,6.568,4.385Zm1-.881a.277.277,0,0,0-.2.077l-.507.511L7.906,5.133l.514-.509a.283.283,0,0,0,0-.393l-.653-.65A.277.277,0,0,0,7.57,3.5Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/Draft.30f3f38f389817ca23f2cf4d4ba73f2c.svg";
export { ForwardRef as ReactComponent };